export default __webpack_public_path__ + "static/beatbugs-banner-4089c9977c8a412060c65f44541dc62a.webp";